<template>
  <div class="folder-view d-flex flex-column h-100 w-100">
    <div class="folder-view-header d-flex align-items-center mb-4">
      <div class="folder-view-header-title text-truncate mr-4">
        {{ folder.name }}
      </div>

      <div class="d-flex ml-auto flex-shrink-0 align-items-center flex-gap-1">
        <eg-button
          v-if="!(folder.maxDepth === 3 && folder.hierarchyLevel === 1)"
          type="secondary"
          icon="metrics-screen"
          icon-size="extra-medium"
          @click="goToMetrics(metricsRoute)"
          >{{ $t("common.viewMetrics") }}</eg-button
        >
        <eg-button
          v-if="workspaceKey === 'essaygrader'"
          type="primary"
          :icon="isNeedShowNewAssignment ? 'file-document' : 'add-folder'"
          icon-size="extra-medium"
          @click="handleNewFolder"
        >
          New {{ isNeedShowNewAssignment ? "Assignment" : "Folder" }}
        </eg-button>
      </div>
    </div>

    <div class="folder-view-content">
      <div class="folder-view-content-item d-flex flex-wrap">
        <folder-thumbnail
          v-for="childFolder in folder.children"
          :key="childFolder.id"
          :folder-id="childFolder.id"
          :workspace-key="workspaceKey"
          :name="childFolder.name"
          :entity="childFolder.entity"
          :items-count="childFolder.essaysCount"
          :is-folder="!childFolder.isAssignment"
          :has-grading-details="!!childFolder.hasGradingDetails"
          class="mr-3 mb-3"
        />
      </div>
    </div>

    <empty-state
      v-if="noChildren"
      class="flex-grow-1"
      title="This folder is empty, create or upload a new assignment."
    >
      <img
        src="@/assets/illustrations/empty-state-submissions-new.svg"
        alt="Empty state"
        class="empty-state-image"
      />
    </empty-state>
  </div>
</template>

<script>
import FolderThumbnail from "@/components/global/folder_thumbnail.vue";
import EmptyState from "@/components/global/empty_state.vue";
import NewFolderModal from "@/components/global/modals/new_folder_modal.vue";
import goToMetricsMixin from "@/mixins/goToMetricsMixin.js";

export default {
  name: "FolderView",

  components: {
    FolderThumbnail,
    EmptyState,
  },

  mixins: [goToMetricsMixin],

  inject: ["workspacesProvider"],

  props: {
    folder: {
      type: Object,
      required: true,
    },
  },

  computed: {
    workspaceKey() {
      return this.$route.params.workspaceKey;
    },

    metricsRoute() {
      const clerkUserId = this.$store.getters.clerkUserId;
      return `/metrics/user/${clerkUserId}/class/${this.folder.id}`;
    },

    noChildren() {
      return (
        !this.folder.children ||
        (this.folder.children && this.folder.children.length === 0)
      );
    },

    isNeedShowNewAssignment() {
      return (
        (this.folder.hierarchyLevel === 2 && this.folder.maxDepth === 3) ||
        (this.folder.hierarchyLevel === 1 && this.folder.maxDepth === 2)
      );
    },
  },

  methods: {
    handleNewFolder() {
      this.$egModal.show("new-folder-modal", {
        component: NewFolderModal,
        props: {
          folderId: this.folder.id,
          workspaceKey: this.workspaceKey,
          isFolder: !this.isNeedShowNewAssignment,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.folder-view-header-title {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
}
</style>
